import { retryFailedTranslations } from './translationRequest';

const pendingChanges = new WeakMap();

// Download without changing language first. A suspended/abandoned request must
// not own the commit queue or apply its language when it eventually returns.
// loadLanguages is unsuitable here: it adds every requested language to global
// preload, making later switches wait for an unrelated stalled download again.
export default async function changeLanguageInOrder(i18n, language, isCurrent) {
  if (!isCurrent()) return;
  if (typeof i18n.loadResources === 'function') {
    await retryFailedTranslations(i18n, language);
    await new Promise((resolve, reject) => i18n.loadResources(language, error => {
      if (error) reject(new Error('Translations unavailable'));
      else resolve();
    }));
    if (!isCurrent()) return;
  }
  // Resources are now ready, so only the short application phase is ordered.
  const changing = (pendingChanges.get(i18n) || Promise.resolve())
    .catch(() => undefined)
    .then(() => isCurrent() ? i18n.changeLanguage(language) : undefined);
  pendingChanges.set(i18n, changing);
  try {
    await changing;
  } finally {
    if (pendingChanges.get(i18n) === changing) pendingChanges.delete(i18n);
  }
}
